import React, { useState, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { useSelector } from 'react-redux';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { toast } from "react-toastify";
import { Dropdown } from 'primereact/dropdown';
import { leaveService } from '../../../services/extensions';
import { LeaveStatus } from '../../../common/util/constants'
import { utitService } from '../../../services/util';
import { selectData } from '../../../services/store/userSlice';
import { Dialog } from 'primereact/dialog';
import { ViewLeave } from './view-leave';
import ConfirmBox from '../../../components/confirmbox/confirmbox';
import properties from '../../../config/environmentProperties';
import { Menu } from 'primereact/menu';
const ManagerApproval = ({ data = [], reload }) => {
    const { currentEnvironment } = properties;
    const userData = useSelector(selectData);
    const [selectedLeaves, setSelectedLeaves] = useState([]);
    const [selLeaves, setSelLeaves] = useState({});
    const [selLeave, setSelLeave] = useState({});
    const [viewDialog, setViewDialog] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [isNoteRequired, setIsNoteRequired] = useState(false);
    const [viewTabIndex, setViewTabIndex] = useState(0);
    const [action, setAction] = useState('');
    const [showEsauRejectWarning, setShowEsauRejectWarning] = useState(false);
    const [esauWarningLeave, setEsauWarningLeave] = useState(null);
    // For bulk reject: tracks if any selected leaves are ESAU auto-leaves
    const [showEsauBulkRejectWarning, setShowEsauBulkRejectWarning] = useState(false);
    const menu = useRef(null);

    const viewLeave = (row, tabIndex = 0) => {
        setSelLeaves(row);
        setViewDialog(true);
        setViewTabIndex(tabIndex)
    }
   const updateLeaveById = (reason) => {
        const LEAVE_STATUS = (action === 'APPROVE' ? 'APPROVED' : 'REJECTED');
        try {
            const leaveReason = reason === '' ? LEAVE_STATUS : reason;
            const ids = selLeave.map(x => x.id);
            const payload = { leaves: ids, status: LeaveStatus[LEAVE_STATUS], reason: leaveReason };
            // console.log("Payload", payload)
            if (ids.length > 0) { // Check if there are any leaves to process
                leaveService.approveRejectLeaveByManager([payload]).then(resp => {
                    if (resp?.data?.success === false) {
                        // Backend validation failed (e.g. insufficient leave balance) —
                        // do NOT run the success flow, show the exact backend error instead.
                        toast.error(resp.data.error || "Unable to " + LEAVE_STATUS.toLocaleLowerCase() + " leave");
                        return;
                    }
                    toast.success("Request has been " + LEAVE_STATUS.toLocaleLowerCase());
                    setSelLeave([]); // Corrected from selLeave([]) to setSelLeave([])
                    setSelectedLeaves([]);
                    reload();
                }).catch(err => {
                    const errMsg = err?.response?.data?.error || "Unable to " + LEAVE_STATUS.toLocaleLowerCase() + " leave";
                    toast.error(errMsg);
                });
            }
        } catch (error) {
            toast.error("Unable to approve leave");
        }
    }

    const onApprove = (row, op) => {
        setAction('APPROVE');
        setIsNoteRequired(false);
        setSelLeave([row]);
        setShowDialog(true)
    }
    const onReject = (row) => {
        //  If this leave was auto-applied from a timesheet,
        // show a warning dialog before rejecting so the manager knows
        // the linked LH timesheet entry will also be removed.
        const isAutoLeave = row?.reasonOfLeave === "Auto-applied from timesheet";

        if (isAutoLeave) {
            setEsauWarningLeave(row);
            setShowEsauRejectWarning(true);
        } else {
            setAction('REJECT');
            setIsNoteRequired(true);
            setSelLeave([row]);
            setShowDialog(true);
        }
    }

    const acceptAllLeave = () => {
        setAction('APPROVE');
        setSelLeave(selectedLeaves);
        setShowDialog(true)
    }
    const rejectAllLeave = () => {
        // Check if any of the selected leaves are ESAU auto-applied from a timesheet.
        // If so, warn the manager that the linked LH timesheet entries will also be removed.
        const hasAutoLeaves = selectedLeaves.some(
            (leave) => leave?.reasonOfLeave === "Auto-applied from timesheet"
        );
        if (hasAutoLeaves) {
            // Store selected leaves in selLeave so onConfirm can process them after warning
            setSelLeave(selectedLeaves);
            setShowEsauBulkRejectWarning(true);
        } else {
            setAction('REJECT');
            setSelLeave(selectedLeaves);
            setShowDialog(true);
        }
    }

    const renderActions = (rowData, options) => {

        return (
            <div className='action-column'>
                {rowData.attachment !== null && <Button icon="pi pi-link" className="p-button p-button-text p-button-sm p-button-warning p-0 m-0" onClick={() => viewLeave(rowData, 1)} />}
                <Button icon="pi pi-eye" className="p-button p-button-text p-button-sm p-button-info p-0 m-0" onClick={() => viewLeave(rowData, 0)} />
                <Button icon="pi pi-check" className="p-button p-button-text p-button-sm p-button-success p-0 m-0" onClick={() => onApprove(rowData, options)} />
                <Button icon="pi pi-times" className="p-button p-button-text p-button-sm p-button-danger p-0 m-0" onClick={() => onReject(rowData)} />
            </div>
        )
    }

    const renderAbsenceCode = (rowData, options) => {
        const ac = userData.localAbsenceCodesArray.find(x => x.title == rowData.absenceCode || x.code == rowData.absenceCode);
        return (<>
            <strong>{rowData?.absenceCode}</strong>
            <em> ({rowData?.LeaveAbsenceCode?.title})</em>
            <span className='ess-link' onClick={() => viewLeave(rowData, 1)}>{rowData.attachment !== null && <i className='pi pi-link' />}
            </span>
        </>)
    }
    const renderAbsenceDuration = (rowData, options) => {
        return (<>
            <strong>{rowData.leaveType}</strong>
            {userData.leaveCode && <em> ({rowData?.LeaveType?.title})</em>}
        </>)
    }
    const renderReasonOfLeave = (rowData, options) => {
        const reason = rowData[options.field] || '';
        const txt = reason.substr(0, 200);
        return (<>
            <span className='noet'>{txt}</span>
        </>)
    }

    const paginatorTmpl = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 50, value: 50 }
            ];

            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Items per page: </span>
                    <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (

                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    }
    const paginationLeft = (e) => {
        return (<div className='ess-header-label pt-1' style={{ marginLeft: '-17px' }}>
            <Button label="Approve All" disabled={selectedLeaves.length === 0} className="p-button-primary p-button-sm ml-2" icon="pi pi-check" onClick={() => acceptAllLeave()} />
            <Button label="Reject All" disabled={selectedLeaves.length === 0} className="p-button-danger p-button-sm ml-2" icon="pi pi-trash" onClick={() => rejectAllLeave()} />
        </div>)
    }

    const rowClass = (data) => {
        return {
            'recalled-manager': data.recallReason !== ''
        }
    }

    const renderLeaves = () => {
        const leaves = [];
        data.map((resource, resIndex) => {
            resource.Leaves.map((leave, leaveIndex) => {
                leaves.push({
                    ...resource, ...leave, Leaves: undefined
                })
            })
        });
        const renderResource = (data) => (<div className='grid ess-resource'>
            <div className='col-fixed image' >
                <img src={currentEnvironment.docPath + 'images/' + data?.user?.photo} alt={data.firstName} style={{ verticalAlign: 'middle' }}
                    tag={currentEnvironment.docPath + 'images/' + data.photo}
                    onError={(e) => { e.target.src = '/assets/images/avtar.png' }} />
            </div>
            <div className='col label'>
                <h2 className='m-0'>{data.firstName} {data.lastName} <small>( ECN: <strong>{data.ecn}</strong> )</small></h2>
            </div>
        </div>)

        return (<>
            <DataTable value={leaves} responsiveLayout="scroll"
                rowGroupMode="subheader" groupRowsBy="ecn"
                rowGroupHeaderTemplate={renderResource}
                paginator rows={10} rowsPerPageOptions={[5, 10, 25, 50]}
                paginatorLeft={(e) => paginationLeft(e)}
                paginatorTemplate={paginatorTmpl}
                selection={selectedLeaves}
                onSelectionChange={(e) => setSelectedLeaves(e.value)}
                selectionMode="multiple"
                dataKey='id'
                rowClassName={rowClass}
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                <Column field="startDate" header="Date" headerStyle={{ width: '100px' }} body={(rowData) => (utitService.dateWithMonthConverter(rowData.startDate))} />
                <Column header="Day" headerStyle={{ width: '100px' }} body={(rowData) => (utitService.dateParser(rowData.startDate, 'dddd'))} />
                <Column field="absenceCode" header="Absence Code" headerStyle={{ width: '220px' }} body={renderAbsenceCode} />
                <Column field="leaveType" header="Leave Type" headerStyle={{ width: '180px' }} body={renderAbsenceDuration} />
                <Column field="reasonOfLeave" header="Reason of leave" body={renderReasonOfLeave} />
                <Column field="recallReason" header="Recall Reason" body={renderReasonOfLeave} />
                <Column header="Actions" headerClassName='center-header' headerStyle={{ width: '130px', textAlign: 'center' }} bodyStyle={{ textAlign: 'right' }} body={renderActions} />
            </DataTable>
        </>)

    }
    return (
        <div className='ess-mgr-approvals'>
            {ViewLeave({ visible: viewDialog, onHide: () => setViewDialog(false), style: { width: '900px' }, leave: selLeaves, header: 'Leave Details', tabIndex: viewTabIndex })}
            <ConfirmBox title={action === 'APPROVE' ? 'Approve' : 'Reject'}
                message={action === 'APPROVE' ? 'You can mention leave approval note here.' : 'You can mention leave rejection reason here.'}
                placeholder={'Enter note for ' + (action === 'APPROVE' ? 'approval' : 'rejection') + '.'}
                visible={showDialog} onCancel={() => setShowDialog(false)} onConfirm={updateLeaveById} required={isNoteRequired} />

            {/*  Warning dialog shown before rejecting an auto-applied leave for ESAU region only. */}
            <Dialog
                header="Are you sure you want to reject this leave?"
                visible={showEsauRejectWarning}
                style={{ width: '500px' }}
                onHide={() => setShowEsauRejectWarning(false)}
                footer={
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            className="p-button-secondary p-button-sm"
                            onClick={() => setShowEsauRejectWarning(false)}
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            className="p-button-danger p-button-sm"
                            onClick={() => {
                                setShowEsauRejectWarning(false);
                                setAction('REJECT');
                                setIsNoteRequired(true);
                                setSelLeave([esauWarningLeave]);
                                setShowDialog(true);
                            }}
                        />
                    </div>
                }
            >
                <div style={{ lineHeight: '1.6' }}>
                    <p>
                        This leave was <strong>auto-submitted from a timesheet</strong>.
                        Rejecting it will also <strong>remove the corresponding Leave
                        entry from the linked timesheet</strong>.
                    </p>
                </div>
            </Dialog>

            {/* Bulk reject warning — shown when one or more selected leaves were auto-applied
                from a timesheet. All selected leaves (auto and manual) will be rejected;
                the auto-applied ones will also have their LH timesheet entries removed. */}
            <Dialog
                header="Are you sure you want to reject the selected leaves?"
                visible={showEsauBulkRejectWarning}
                style={{ width: '520px' }}
                onHide={() => setShowEsauBulkRejectWarning(false)}
                footer={
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            className="p-button-secondary p-button-sm"
                            onClick={() => setShowEsauBulkRejectWarning(false)}
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            className="p-button-danger p-button-sm"
                            onClick={() => {
                                setShowEsauBulkRejectWarning(false);
                                setAction('REJECT');
                                setIsNoteRequired(true);
                                setShowDialog(true);
                            }}
                        />
                    </div>
                }
            >
                <div style={{ lineHeight: '1.6' }}>
                    <p>
                        One or more of the selected leaves were <strong>auto-submitted from a timesheet</strong>.
                        Rejecting them will also <strong>remove the corresponding Leave
                        entries from the linked timesheets</strong>.
                    </p>
                </div>
            </Dialog>

            <div className='ess-panel'>
                {renderLeaves()}
            </div>
        </div>
    )
}

export default ManagerApproval